import MicroModal from 'micromodal';

// Карта Яндекса в модалке "Где мы находимся?" подгружается при первом открытии,
// чтобы не тянуть бандл карт на каждой странице
let addressMapLoaded = false;
const loadAddressMap = (modal) => {
    if (addressMapLoaded) {
        return;
    }
    const container = modal.querySelector('[data-map-src]');
    if (!container) {
        return;
    }
    addressMapLoaded = true;
    const script = document.createElement('script');
    script.async = true;
    script.charset = 'utf-8';
    script.src = container.getAttribute('data-map-src');
    container.appendChild(script);
};

// Vue-приложения модалок (Vue + Pinia, ~100 KB gzip) не входят в основной бандл:
// app.js греет их чанк на первом взаимодействии, а здесь мы гарантируем загрузку
// в момент открытия — на случай, если модалку открыли без предварительных событий
// (клавиатурой или сразу после загрузки страницы). import() кэшируется, повторный
// вызов ничего не стоит.
const MODAL_APPS = {
    'modal-bid': () => import('@/js/modal-bid'),
    'modal-visit': () => import('@/js/modal-visit'),
};

MicroModal.init({
    disableScroll: false,
    onShow: (modal) => {
        if (modal.id === 'modal-address') {
            loadAddressMap(modal);
            return;
        }
        const loadApp = MODAL_APPS[modal.id];
        if (loadApp) {
            loadApp();
        }
    }
});
